import React, { memo, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionWithRef } from 'site-modules/shared/components/css-transition-with-ref/css-transition-with-ref';

import './height-collapse-transition.scss';

export const HeightCollapseTransition = memo(function HeightCollapseTransition({
  isOpen,
  timeout = 300,
  children,
  ...rest
}) {
  const nodeRef = useRef(null);

  const handleEnter = useCallback(() => {
    const transitionNode = nodeRef.current;
    if (!transitionNode) return;
    transitionNode.style.height = '0';
  }, []);

  const handleEntering = useCallback(() => {
    const transitionNode = nodeRef.current;
    if (!transitionNode) return;
    transitionNode.style.height = `${transitionNode.scrollHeight}px`;
  }, []);

  const handleEntered = useCallback(() => {
    const transitionNode = nodeRef.current;
    if (!transitionNode) return;
    transitionNode.style.height = null;
  }, []);

  const handleExit = useCallback(() => {
    const transitionNode = nodeRef.current;
    if (!transitionNode) return;
    transitionNode.style.height = `${transitionNode.scrollHeight}px`;
  }, []);

  const handleExiting = useCallback(() => {
    const transitionNode = nodeRef.current;
    if (!transitionNode) return;
    transitionNode.style.height = '0';
  }, []);

  return (
    <CSSTransitionWithRef
      in={isOpen}
      timeout={timeout}
      classNames="height-collapse-transition"
      mountOnEnter
      unmountOnExit
      onEnter={handleEnter}
      onEntering={handleEntering}
      onEntered={handleEntered}
      onExit={handleExit}
      onExiting={handleExiting}
      style={{ '--global-search-transition-duration': timeout }}
      {...rest}
      nodeRef={nodeRef}
    >
      {React.cloneElement(children, { ref: nodeRef })}
    </CSSTransitionWithRef>
  );
});

HeightCollapseTransition.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  timeout: PropTypes.number,
};
